import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Pluralize from 'react-pluralize';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import './WebsitesList.scss';

import AddButton from './AddButton';
import EditButton from './EditButton';

function WebsitesList(props) {
  const { list, history, onDelete } = props;
  const options = useMemo(
    () => ({
      insertBtn: AddButton,
      defaultSortName: 'name',
      defaultSortOrder: 'asc',
    }),
    [],
  );

  const editWebsite = (id) => {
    history.push(`/website/${id}/config`);
  };

  const actionFormatter = (_cell, website) => (
    <EditButton
      website={website}
      editWebsite={editWebsite}
      onDelete={onDelete}
    />
  );

  const sourceFormatter = (_cell, website) => {
    if (website.dealer_id && !website.dealergroup_id) {
      return `dealer | <a href="/dealer/${website.dealer_id}">${website.dealer_id}</a>`;
    }

    if (website.dealergroup_id) {
      return `group | <a href="/group/${website.dealergroup_id}">${website.dealergroup_id}</a>`;
    }

    return '';
  };

  return (
    <div className="websites-list-container">
      <h3>
        <Pluralize singular="Website" plural="Websites" count={list.length} />
      </h3>
      <BootstrapTable
        data={list}
        options={options}
        insertRow
        striped
        hover
        pagination
        bodyContainerClass="list-body-container"
        tableStyle={{ border: 'none' }}
      >
        <TableHeaderColumn dataField="id">ID</TableHeaderColumn>
        <TableHeaderColumn
          isKey
          dataField="name"
          dataSort
          filter={{ type: 'TextFilter', defaultValue: '' }}
        >
          Name
        </TableHeaderColumn>
        <TableHeaderColumn dataFormat={sourceFormatter}>
          Website Owner
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="button"
          columnClassName="list-action-column"
          dataFormat={actionFormatter}
        />
      </BootstrapTable>
    </div>
  );
}

WebsitesList.propTypes = {
  list: PropTypes.array,
  history: PropTypes.object,
  onDelete: PropTypes.func,
};

export default withRouter(WebsitesList);
